import React from 'react';
import PropTypes from 'prop-types';
import { Heading } from '@americanexpress/dls-react';
import styles from './HotelDescription.scss';

const HotelDescription = ({ description = '' }) => {
  if (!description) {
    return null;
  }

  return (
    <div className="row">
      <div className="col-xs-12">
        <Heading level={3} variant="sans-medium-bold" className="margin-1-b">
          Hotel Description
        </Heading>
        <div
          className={`${styles.hotelDescription} body`}
          // eslint-disable-next-line react/no-danger -- content is sourced from trusted internal API
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};

HotelDescription.propTypes = {
  description: PropTypes.string,
};

export default HotelDescription;
